import { render, staticRenderFns } from "./POC.vue?vue&type=template&id=460b4107&"
import script from "./POC.vue?vue&type=script&lang=js&"
export * from "./POC.vue?vue&type=script&lang=js&"
import style0 from "./POC.vue?vue&type=style&index=0&id=460b4107&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports